import styled, { css } from 'styled-components'
import lighten from 'polished/lib/color/lighten'
import darken from 'polished/lib/color/darken'
import { colors, sizes } from 'config/ui'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const StyledButton = styled.button`
  ${({
    color,
    outline,
    fluid,
    size,
    multipleChildren,
    sharpBorders,
    newSize,
    noTextTransform,
    textColor,
    textColorHover,
    justifyContent
  }) => css`
    position: relative;
    display: inline-flex;
    justify-content: ${multipleChildren ? 'space-between' : 'center'};
    align-items: center;
    width: ${fluid ? '100%' : 'auto'};
    ${!noTextTransform && 'text-transform: uppercase;'} text-align: center;
    color: ${textColor ? textColor : outline ? color : colors.white};
    border: ${outline ? `1px solid ${color}` : 'none'};
    border-radius: ${sharpBorders ? 0 : sizes.radius}px;
    background-color: ${outline ? colors.white : color};
    padding: 1em 2em;
    cursor: pointer;
    transition: background-color 0.5s;
    outline: none;

    &:focus-visible {
      outline: 2px solid ${tokens.colors.dark6};
      outline-offset: 2px;
    }
    font-weight: ${tokens.fontWeights.bold};
    font-size: ${size === 'x-small'
      ? `${sizes.smallText - 4}px`
      : size === 'small'
      ? `${sizes.smallText - 2}px`
      : size === 'medium'
      ? `${sizes.smallText}px`
      : `${sizes.text}px`};

    > svg {
      margin: 0 10px;
    }

    &:hover {
      background-color: ${outline
        ? color
        : color === '#DFE5E9' ||
          color === colors.gray2 ||
          color === tokens.colors.green_light
        ? darken(0.09, color)
        : lighten(0.1, color)};
      color: ${textColorHover ? textColorHover : colors.white};
    }

    &:active {
      background-color: ${darken(0.1, color)};
      color: ${textColor ? textColor : colors.white};
    }

    &:disabled {
      color: ${colors.gray4};
      border: none;
      justify-content: center;
      cursor: not-allowed;
      background-color: #dfe5e9;
      ${justifyContent && `justify-content: ${justifyContent};`};
    }

    ${newSize &&
    `
      padding: 0 ${newSize === 'large' || newSize === 'medium' ? 16 : 8}px;
      font-size: ${newSize === 'xsmall' ? sizes.label : sizes.buttonText}px;
      height: 48px;
      ${!fluid && 'justify-content: flex-start;'}
	  `} ${justifyContent && `justify-content: ${justifyContent};`};
  `};
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  left: 0;
  top: 0;
  background-color: ${({ color }) =>
    color === '#DFE5E9' || color === colors.gray2
      ? darken(0.09, color)
      : lighten(0.1, color)};
  border-radius: ${props => (props.sharpBorders ? 0 : sizes.radius)}px;
`
